import { Component } from '@angular/core';

@Component({
  selector: 'ott-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {}
